import React, { useEffect, useState } from "react";

import { HStack } from "@whoosh/design-system/src/components/primitive";

import { TabItem } from "./TabItem";

type iTabsProps = {
  tabs: String[];
  activeTabIndex: number;
  setActiveTabIndex?: (value: number) => void;
};

export const Tabs = ({
  activeTabIndex,
  tabs,
  setActiveTabIndex,
}: iTabsProps) => {
  const [currentIndex, setIndex] = useState(activeTabIndex || 0);

  useEffect(() => {
    setIndex(activeTabIndex);
  }, [activeTabIndex]);

  useEffect(() => {
    setActiveTabIndex && setActiveTabIndex(currentIndex);
  }, [currentIndex, setActiveTabIndex]);

  return (
    <HStack
      style={{ borderRadius: 100 }}
      borderWidth={2}
      borderColor="grayscale-500"
      width="auto"
      justifyContent="space-between"
      backgroundColor="grayscale-0"
      maxWidth="100%"
    >
      {tabs.map((tab, index) => (
        <TabItem
          key={index}
          index={index}
          currentIndex={currentIndex}
          setIndex={setIndex}
          label={tab}
        />
      ))}
    </HStack>
  );
};

export default Tabs;
